import { render, staticRenderFns } from "./PriceDetailsCard.vue?vue&type=template&id=7979076a&"
import script from "./PriceDetailsCard.vue?vue&type=script&lang=js&"
export * from "./PriceDetailsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports